import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=303e36a8&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=303e36a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303e36a8",
  null
  
)

export default component.exports